module.exports = __webpack_public_path__ + "img/CLS-P-350.6914932f.svg";